import { Domain } from "src/config/BartLambdaConfig";
import { isProd } from "src/util";

// Reference: https://tiny.amazon.com/16pfxxbk7/TalusCommonClients/mainline/marketplace.test.ts

const COUNTRY_CODE_TO_DOMAIN_MAP: Record<string, Domain> = {
  // US (NA region)
  AI: "prod-US", // Anguilla
  AQ: "prod-US",
  AG: "prod-US",
  AR: "prod-US",
  AS: "prod-US", // American Samoa
  AW: "prod-US", // Aruba
  BS: "prod-US",
  BB: "prod-US",
  BM: "prod-US", // Bermuda
  BZ: "prod-US",
  BO: "prod-US",
  BR: "prod-US", // Brazil - www.amazon.com.br
  CA: "prod-US", // Canada - www.amazon.ca
  CL: "prod-US", // Chile
  CO: "prod-US", // Colombia - www.amazon.com.co
  CR: "prod-US",
  CW: "prod-US", // Curaçao
  DM: "prod-US",
  DO: "prod-US",
  EC: "prod-US",
  SV: "prod-US",
  FK: "prod-US", // Falkland Islands
  GD: "prod-US",
  GF: "prod-US", // French Guiana [UNCERTAIN - French territory, could be prod-EU]
  GL: "prod-US", // Greenland [UNCERTAIN - geographically Americas but politically part of Denmark/EU]
  GP: "prod-US", // Guadeloupe [UNCERTAIN - French territory, could be prod-EU]
  GS: "prod-US", // South Georgia and the South Sandwich Islands
  GT: "prod-US",
  GU: "prod-US", // Guam
  GY: "prod-US",
  HT: "prod-US",
  HN: "prod-US",
  JM: "prod-US",
  KN: "prod-US", // Saint Kitts and Nevis
  KY: "prod-US", // Cayman Islands
  LC: "prod-US", // Saint Lucia
  MQ: "prod-US", // Martinique [UNCERTAIN - French territory, could be prod-EU]
  MS: "prod-US", // Montserrat
  MX: "prod-US", // Mexico - www.amazon.com.mx
  NI: "prod-US",
  PA: "prod-US",
  PM: "prod-US", // Saint Pierre and Miquelon
  PR: "prod-US", // Puerto Rico
  PY: "prod-US",
  PE: "prod-US",
  BL: "prod-US", // Saint Barthélemy
  MF: "prod-US", // Saint Martin
  SR: "prod-US",
  TC: "prod-US", // Turks and Caicos Islands
  TT: "prod-US",
  UM: "prod-US",
  US: "prod-US", // United States - www.amazon.com
  UY: "prod-US",
  VC: "prod-US", // Saint Vincent and the Grenadines
  VE: "prod-US",
  VG: "prod-US", // British Virgin Islands
  VI: "prod-US", // Virgin Islands
  MP: "prod-US", // Northern Mariana Islands

  // EU
  AD: "prod-EU", // Andorra
  AE: "prod-EU", // UAE - www.amazon.ae
  AF: "prod-EU",
  AL: "prod-EU", // Albania
  AM: "prod-EU", // Armenia
  AO: "prod-EU",
  AT: "prod-EU", // Austria
  AX: "prod-EU", // Åland Islands
  AZ: "prod-EU", // Azerbaijan
  BA: "prod-EU", // Bosnia and Herzegovina
  BD: "prod-EU",
  BE: "prod-EU", // Belgium
  BG: "prod-EU", // Bulgaria
  BH: "prod-EU", // Bahrain
  BJ: "prod-EU",
  BT: "prod-EU",
  BV: "prod-EU", // Bouvet Island
  BW: "prod-EU",
  BY: "prod-EU", // Belarus
  BF: "prod-EU",
  BI: "prod-EU",
  CH: "prod-EU", // Switzerland
  CI: "prod-EU",
  CM: "prod-EU",
  CV: "prod-EU", // Cape Verde
  CY: "prod-EU", // Cyprus
  CZ: "prod-EU", // Czech Republic
  DE: "prod-EU", // Germany - www.amazon.de
  DJ: "prod-EU",
  DK: "prod-EU", // Denmark
  DZ: "prod-EU",
  EE: "prod-EU", // Estonia
  EG: "prod-EU", // Egypt - www.amazon.eg
  ER: "prod-EU",
  ES: "prod-EU", // Spain - www.amazon.es
  ET: "prod-EU",
  FI: "prod-EU", // Finland
  FO: "prod-EU", // Faroe Islands
  FR: "prod-EU", // France - www.amazon.fr
  GA: "prod-EU",
  GB: "prod-EU", // United Kingdom - www.amazon.co.uk
  GE: "prod-EU", // Georgia
  GG: "prod-EU", // Guernsey
  GH: "prod-EU",
  GI: "prod-EU", // Gibraltar
  GM: "prod-EU",
  GN: "prod-EU",
  GQ: "prod-EU", // Equatorial Guinea
  GR: "prod-EU", // Greece
  GW: "prod-EU",
  HR: "prod-EU", // Croatia
  HU: "prod-EU", // Hungary
  IE: "prod-EU", // Ireland
  IL: "prod-EU",
  IM: "prod-EU", // Isle of Man
  IN: "prod-EU", // India - www.amazon.in
  IO: "prod-EU", // British Indian Ocean Territory
  IQ: "prod-EU",
  IS: "prod-EU", // Iceland
  IT: "prod-EU", // Italy - www.amazon.it
  JE: "prod-EU", // Jersey
  JO: "prod-EU",
  KE: "prod-EU",
  KG: "prod-EU",
  KM: "prod-EU", // Comoros
  KW: "prod-EU", // Kuwait
  KZ: "prod-EU",
  LB: "prod-EU",
  LI: "prod-EU", // Liechtenstein
  LR: "prod-EU",
  LS: "prod-EU",
  LT: "prod-EU", // Lithuania
  LU: "prod-EU", // Luxembourg
  LV: "prod-EU", // Latvia
  LY: "prod-EU",
  MA: "prod-EU",
  MC: "prod-EU", // Monaco
  MD: "prod-EU", // Moldova
  ME: "prod-EU", // Montenegro
  MG: "prod-EU",
  MK: "prod-EU", // North Macedonia
  ML: "prod-EU",
  MR: "prod-EU",
  MT: "prod-EU", // Malta
  MU: "prod-EU",
  MV: "prod-EU",
  MW: "prod-EU",
  MZ: "prod-EU",
  NA: "prod-EU",
  NE: "prod-EU",
  NG: "prod-EU", // Nigeria
  NL: "prod-EU", // Netherlands - www.amazon.nl
  NO: "prod-EU", // Norway
  NP: "prod-EU",
  OM: "prod-EU", // Oman
  PK: "prod-EU",
  PL: "prod-EU", // Poland - www.amazon.pl
  PS: "prod-EU",
  PT: "prod-EU", // Portugal
  QA: "prod-EU", // Qatar
  RE: "prod-EU", // Réunion [UNCERTAIN - French territory in Indian Ocean, verify mapping]
  RO: "prod-EU", // Romania
  RS: "prod-EU", // Serbia
  RU: "prod-EU", // Russia
  RW: "prod-EU",
  SA: "prod-EU", // Saudi Arabia - www.amazon.sa
  SC: "prod-EU",
  SE: "prod-EU", // Sweden - www.amazon.se
  SH: "prod-EU",
  SI: "prod-EU", // Slovenia
  SJ: "prod-EU", // Svalbard and Jan Mayen
  SK: "prod-EU", // Slovakia
  SL: "prod-EU",
  SM: "prod-EU", // San Marino
  SN: "prod-EU",
  SO: "prod-EU",
  SS: "prod-EU",
  ST: "prod-EU",
  SZ: "prod-EU",
  TD: "prod-EU",
  TF: "prod-EU", // French Southern Territories [UNCERTAIN - French territory, could be grouped with FR]
  TG: "prod-EU", // Togo
  TJ: "prod-EU",
  TN: "prod-EU",
  TR: "prod-EU", // Turkey - www.amazon.com.tr / www.amazon.tr
  TM: "prod-EU",
  TZ: "prod-EU",
  UA: "prod-EU", // Ukraine
  UG: "prod-EU",
  UZ: "prod-EU",
  VA: "prod-EU", // Vatican City
  XK: "prod-EU", // Kosovo
  YE: "prod-EU",
  YT: "prod-EU", // Mayotte [UNCERTAIN - French territory, could be grouped with FR]
  ZA: "prod-EU", // South Africa
  ZM: "prod-EU",
  ZW: "prod-EU",
  CF: "prod-EU",
  CG: "prod-EU",
  CD: "prod-EU",
  LK: "prod-EU",
  EH: "prod-EU",

  // FE
  AU: "prod-FE", // Australia - www.amazon.com.au
  BN: "prod-FE",
  CC: "prod-FE",
  CK: "prod-FE",
  CX: "prod-FE",
  FJ: "prod-FE",
  FM: "prod-FE",
  HK: "prod-FE",
  HM: "prod-FE",
  ID: "prod-FE", // Indonesia
  JP: "prod-FE", // Japan - www.amazon.co.jp
  KH: "prod-FE", // Cambodia
  KI: "prod-FE",
  KR: "prod-FE",
  LA: "prod-FE",
  MH: "prod-FE",
  MM: "prod-FE",
  MN: "prod-FE",
  MO: "prod-FE",
  MY: "prod-FE",
  NC: "prod-FE", // New Caledonia [UNCERTAIN - French territory, could be prod-EU]
  NF: "prod-FE",
  NR: "prod-FE",
  NU: "prod-FE",
  NZ: "prod-FE",
  PF: "prod-FE", // French Polynesia [UNCERTAIN - French territory, could be prod-EU]
  PG: "prod-FE",
  PH: "prod-FE",
  PN: "prod-FE",
  PW: "prod-FE",
  SB: "prod-FE",
  SG: "prod-FE", // Singapore - www.amazon.sg
  TH: "prod-FE",
  TK: "prod-FE",
  TL: "prod-FE",
  TO: "prod-FE",
  TV: "prod-FE",
  TW: "prod-FE",
  VN: "prod-FE", // Vietnam
  VU: "prod-FE",
  WF: "prod-FE", // Wallis and Futuna [UNCERTAIN - French territory, could be grouped with FR]
  WS: "prod-FE",
};

export const getDomainFromCountry = (countryCode: string): Domain => {
  if (isProd()) {
    return COUNTRY_CODE_TO_DOMAIN_MAP[countryCode];
  } else {
    return "devo-FE";
  }
};

export const SUPPORTED_COUNTRY_CODES = Object.keys(COUNTRY_CODE_TO_DOMAIN_MAP);
